import { heroEquipment } from "../HeroEquipment";

export const pestilens = {
  heroes: {
    "Diakon zarazy": {
      id: 0,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 65,
      number: 1,
      equipmentList: heroEquipment["Kult Zarazy klanu Pestilens"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 5, 1, 7],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Dowódca","Mag (Tradycja Zarazy)","Ranger","Strachliwy","Twardziel","W nogi!"],
      exp: 20,
      skills: [0, 2, 4, 5],
    },
    "Mnich zarazy": {
      id: 1,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Kult Zarazy klanu Pestilens"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Ranger", "Twardziel", "W nogi!"],
      exp: 8,
      skills: [0, 2, 4, 5],
    },
    Kadzielnik: {
      id: 2,
      startingEquipment: ["Sztylet", "Cep bojowy"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Kult Zarazy klanu Pestilens"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 5, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Ranger", "Twardziel", "W nogi!"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    "Łowca niewolników": {
      id: 3,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Kult Zarazy klanu Pestilens"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 5, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Handlarz niewolników", "Ranger", "Twardziel", "W nogi!"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    "Czciciel zarazy": {
      id: 5,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 25,
      number: 15,
      equipmentList: heroEquipment["Kult Zarazy klanu Pestilens"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 4, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Ranger",
        "Twardziel",
        "W nogi!",
      ],
    },
    "Siewca zarazy": {
      id: 6,
      startingEquipment: ["Cep bojowy"],
      cost: 50,
      number: 5,
      equipmentList: heroEquipment["Kult Zarazy klanu Pestilens"].Siewca,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 4, 4, 1, 4, 1, 10],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Fanatyk", "Furia", "Ranger", "Twardziel", "W nogi!"],
    },
    "Szczur zarazy": {
      id: 7,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 25,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 0, 3, 3, 1, 3, 1, 3],
        Maksymalna: [6, 3, 0, 3, 3, 1, 3, 1, 3],
      },
      rules: [
        "Murołaz",
        "Sfora",
        "Rozmiar rzondzi",
        "Twardziel",
        "W nogi!",
        "Wodny",
        "Zwierzę",
      ],
    },
    "Czerw zarazy": {
      id: 8,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 200,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["K6", 3, "-", 4, 4, 3, 1, 3, 2],
        Maksymalna: ["K6", 3, "-", 4, 4, 3, 1, 3, 2],
      },
      rules: [
        "Duży cel",
        "Głód krwi",
        "Głód trzewi",
        "Łuskowata skóra (5+)",
        "Murołaz",
        "Przepastne trzewia",
        "Saper",
        "Strach",
        "Stygmaty Nurgla (odór, rój much)",
        "Trafienie z uderzenia",
        "Tratowanie",
        "Wielkolud",
        "Wodny",
        "Wyklęty",
        "Zimnokrwisty",
        "Zwierzę",
        "Żrąca plwocina",
      ],
    },
    Zarazowóz: {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Zarazowóz"],
    },
    Więźniarka: {
      id: 10,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Kult Zarazy klanu Pestilens",
  nature: "Chaotyczna",
  armyRules: ["Rozrzutność"],
  mercenaries: ["Szczurogr", "Szpieg", "Złodziej"],
};
